/** Stable identity shared by every version of an injection-molded product. */
export interface InjectionMoldingProduct {
    id: string;
    qtyOnHand: number;
}

export function injectionMoldingLabelQuantity(
    defaultBoxQuantity: number | null | undefined,
    orderedQuantity: number,
): number {
    if (Number.isInteger(defaultBoxQuantity) && Number(defaultBoxQuantity) > 0) {
        return Number(defaultBoxQuantity);
    }

    return Math.max(1, Math.floor(orderedQuantity));
}
